export const handleFindActiveItem = (list:Array<any>) => {
    return list?.length > 0 && list.find((item:any) => item?.active === true);
}